import { roundNumber } from './common';

export function SpotInvestments(quality, channels) {
    const quality_arr = [1500, 1900, 2700, 3700, 5500];
    const base = quality_arr[quality - 1];
    return base + (channels.length - 1) * base * 0.5;
}

export function CheckBudget(channels, media, budget) {
    let common_channels = 0;
    let res = false;
    const coverage_channels = new Array(channels.length).fill(0);
    
    let targeted_sum = 0;
    
    channels.forEach(channel => {
        const index = channels.indexOf(channel);
        
        if (channel == 'TV') {
            common_channels+= media[0]['tv_cost'];
            coverage_channels[index] = media[0]['tv_cost'];
        } 
        else if(channel == 'outdoor ads') {
            common_channels+= media[0].outdoor_advertising_cost;
            coverage_channels[index] = media[0].outdoor_advertising_cost;
        }
        else if (channel == 'autoradio podcasts') {
            common_channels+= media[0]['autoradio_podcasts_cost'];
            coverage_channels[index] = media[0].autoradio_podcasts_cost;
        }   
    });
    //console.log(common_channels);

    if (common_channels > 0) { /* we have some common channels*/
        const rest = budget - common_channels; //summa for targeted channels
        const targeted_channels = coverage_channels.filter(chan => chan == 0);
        
        if (targeted_channels.length > 0) {
            targeted_sum = roundNumber(rest / targeted_channels.length);
        }
        
        if (rest >= 10) {
            res = coverage_channels.map(chan => chan == 0 ? targeted_sum : chan);
        }
    }
    else {  /* we have only targeted channels*/
        if (budget > 1000) {
            targeted_sum = roundNumber(budget / channels.length);
            res = coverage_channels.map(chan => chan == 0 ? targeted_sum : targeted_sum);
        }
    }
    return res;
}

export function SpotCoverageCost(channels, marketSize, media, coverage_channels) {
    let res = [0, 0];
    let common_max = { coverage: 0 }; /* max common channel */
    let targeted_max = { coverage: 0 }; /* max targeted channel */
    let index = 0;
    let coverage = 0; /* */
    /* console.log(marketSize) */


    channels.forEach(channel => {

        if(channel == 'TV') {
            if (common_max.coverage < media[0].tv_coverage) {
                common_max.coverage = media[0].tv_coverage;
                common_max.channel = channel;
            }
        }
        else if(channel == 'outdoor ads') {
           if (common_max.coverage < media[0].outdoor_advertising_coverage) {
                common_max.coverage = media[0].outdoor_advertising_coverage;
                common_max.channel = channel;
            } 
        } 
        else if(channel == 'autoradio podcasts') {
           if (common_max.coverage < media[0].autoradio_podcasts_coverage) {
                common_max.coverage = media[0].autoradio_podcasts_coverage;
                common_max.channel = channel;
            } 
        }
        /* targeted */
        else if(channel == 'postal mailings') {
            if (targeted_max.coverage < media[0].postal_coverage) {
                targeted_max.coverage = media[0].postal_coverage;
                targeted_max.channel = channel;
            } 
        }
        else if(channel == 'SMM') {
            if (targeted_max.coverage < media[0].smm_coverage) {
                targeted_max.coverage = media[0].smm_coverage;
                targeted_max.channel = channel;
            } 
        }
        else if(channel == 'content ads') {
            if (targeted_max.coverage < media[0].content_ads_coverage) {
                targeted_max.coverage = media[0].content_ads_coverage;
                targeted_max.channel = channel;
            } 
        }
        else if(channel == 'bloggers & influencers') {
            if (targeted_max.coverage < media[0].bloggers_influencers_coverage) {
                targeted_max.coverage = media[0].bloggers_influencers_coverage;
                targeted_max.channel = channel;
            } 
        }
        else if(channel == 'banner ads') {
            if (targeted_max.coverage < media[0].banner_ads_coverage) {
                targeted_max.coverage = media[0].banner_ads_coverage;
                targeted_max.channel = channel;
            } 
        }
    })

   channels.forEach(channel => {

        switch(channel) {
            case 'TV': 
                if (common_max.channel == channel) {
                    res[0] += marketSize * media[0].tv_coverage;
                }
                else {
                    res[0] += marketSize * media[0].tv_coverage * 0.2;
                }
            break;
            case 'outdoor ads': 
                if (common_max.channel == channel) {
                    res[0] += marketSize * media[0].outdoor_advertising_coverage;
                }
                else {
                    res[0] += marketSize * media[0].outdoor_advertising_coverage * 0.2;
                }
            break;
            case 'autoradio podcasts': 
                if (common_max.channel == channel) {
                    res[0] += marketSize * media[0].autoradio_podcasts_coverage;
                }
                else {
                    res[0] += marketSize * media[0].autoradio_podcasts_coverage * 0.2;
                }
            break;
            case 'postal mailings': 
                index = channels.indexOf(channel);
                if (channel == targeted_max.channel) {
                   coverage = roundNumber(coverage_channels[index] / media[0].postal_cost); 
                }
                else {
                    coverage = roundNumber((coverage_channels[index] / media[0].postal_cost) * 0.4);
                }
                coverage = coverage > (marketSize * media[0].postal_coverage) ? (marketSize * media[0].postal_coverage) : coverage;
                res[1]+= coverage;
            break;
            case 'SMM': index = channels.indexOf(channel);
                if (channel == targeted_max.channel) {
                   coverage = roundNumber(coverage_channels[index] / media[0].smm_cost); 
                }
                else {
                    coverage = roundNumber((coverage_channels[index] / media[0].smm_cost) * 0.4);
                }
                coverage = coverage > (marketSize * media[0].smm_coverage) ? (marketSize * media[0].smm_coverage) : coverage;
                res[1]+= coverage;
            break;
            case 'content ads': 
                index = channels.indexOf(channel);
                if (channel == targeted_max.channel) {
                   coverage = roundNumber(coverage_channels[index] / media[0].content_ads_cost); 
                }
                else {
                    coverage = roundNumber((coverage_channels[index] / media[0].content_ads_cost) * 0.4);
                }
                coverage = coverage > (marketSize * media[0].content_ads_coverage) ? (marketSize * media[0].content_ads_coverage) : coverage;
                res[1]+= coverage;
            break;
            case 'bloggers & influencers': 
                index = channels.indexOf(channel);
                if (channel == targeted_max.channel) {
                   coverage = roundNumber(coverage_channels[index] / media[0].bloggers_influencers_cost); 
                }
                else {
                    coverage = roundNumber((coverage_channels[index] / media[0].bloggers_influencers_cost) * 0.4);
                }
                coverage = coverage > (marketSize * media[0].bloggers_influencers_coverage) ? (marketSize * media[0].bloggers_influencers_coverage) : coverage;
                res[1]+= coverage;
            break;
            case 'banner ads': 
                index = channels.indexOf(channel);
                if (channel == targeted_max.channel) {
                   coverage = roundNumber(coverage_channels[index] / media[0].banner_ads_cost); 
                }
                else {
                    coverage = roundNumber((coverage_channels[index] / media[0].banner_ads_cost) * 0.4);
                }
                coverage = coverage > (marketSize * media[0].banner_ads_coverage) ? (marketSize * media[0].banner_ads_coverage) : coverage;
                res[1]+= coverage;
            break;
        }
    })
    res[0] = res[0] > marketSize ? marketSize : res[0];
    /* console.log(res) */
    return res;
}

